var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4964 7.80005V15.6766C18.528 16.2551 18.3501 16.8237 18.0016 17.2589C17.653 17.694 17.162 17.9604 16.6354 18H3.36456C2.83799 17.9604 2.34699 17.694 1.99845 17.2589C1.64991 16.8237 1.47204 16.2551 1.50358 15.6766V7.80005",
    stroke: "#888888",
    strokeWidth: 2.108,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73071 1.11169L7.29041 3.8549L4.96227 6.46881C4.92591 6.50964 4.90416 6.55784 4.89942 6.60808C4.89468 6.65832 4.90713 6.70864 4.93539 6.75349C4.96366 6.79835 5.00664 6.83598 5.05959 6.86223C5.11254 6.88849 5.17339 6.90234 5.23542 6.90226H8.34866L8.34866 14.6H11.6464L11.6464 6.90226H14.7615C14.8235 6.90234 14.8843 6.88849 14.9373 6.86223C14.9902 6.83598 15.0332 6.79835 15.0615 6.75349C15.0897 6.70864 15.1022 6.65832 15.0975 6.60808C15.0927 6.55784 15.071 6.50964 15.0346 6.46881L12.7137 3.8549L10.2734 1.11169C10.2422 1.07708 10.2013 1.04892 10.1542 1.02952C10.107 1.01011 10.0549 1 10.0021 1C9.94921 1 9.8971 1.01011 9.84996 1.02952C9.80281 1.04892 9.76196 1.07708 9.73071 1.11169Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.8947d0c8ba8d4f9b3432ce4c1a5e1bf2.svg";
export { ForwardRef as ReactComponent };